import { components, SingleValueProps } from 'react-select';
import TimezoneFormat from '../TimezoneFormat';

interface Props
  extends SingleValueProps<{
    code: string;
    name: string;
    flag: string;
  }> {}

const SingleValue: React.FC<Props> = ({ data, ...props }) => {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <components.SingleValue {...(props as SingleValueProps)}>
      <TimezoneFormat data={data} />
    </components.SingleValue>
  );
};

export default SingleValue;
